import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SectionHeader from './SectionHeader';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: HourglassEmptyIcon,
      title: "No Account Connections Required",
      description: "Works with publicly available data only. Analyze any business worldwide - including competitors, suppliers, and clients."
    },
    {
      icon: TrackChangesIcon,
      title: "Quantitative Revenue Impact Analysis",
      description: "Don't just know what customers like or dislike. See exactly how customer experience issues affect your ratings and revenue."
    },
    {
      icon: DataUsageIcon,
      title: "10x Cheaper Than Existing Solutions",
      description: "Pay monthly, cancel anytime. No contracts, no commitments. Start analyzing your reviews today."
    },
    {
      icon: CheckCircleOutlineIcon,
      title: "All Review Platforms in One Dashboard",
      description: "Analyze reviews from every platform without switching tools or managing multiple accounts."
    }
  ];

  return (
    <Box
      id="features"
      sx={{
        py: { xs: 8, md: 12 },
        background: 'linear-gradient(180deg, #f8f9fe 0%, #ffffff 100%)'
      }}
    >
      <Container maxWidth="lg">
        <SectionHeader 
          title="Get Enterprise-Level Customer Experience Insights at Small Business Prices"
        />
        
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }}>
          {/* Left Column: Benefits List */}
          <Box sx={{ 
            flexGrow: 1, 
            flexBasis: { xs: '100%', md: 'calc(50% - 16px)' }, 
            maxWidth: { xs: '100%', md: 'calc(50% - 16px)' }, 
            minWidth: 0 
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {benefits.map((benefit, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <benefit.icon sx={{ fontSize: 32, color: 'common.black', mt: 0.5 }} />
                  <Box>
                    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                      {benefit.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#546E7A', lineHeight: 1.6 }}>
                      {benefit.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Right Column: Visual */}
          <Box sx={{ 
            flexGrow: 1, 
            flexBasis: { xs: '100%', md: 'calc(50% - 16px)' }, 
            maxWidth: { xs: '100%', md: 'calc(50% - 16px)' }, 
            minWidth: 0 
          }}>
            <Box sx={{
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 12px 24px -8px rgba(0,0,0,0.1)'
            }}>
              <img
                src="/example_insight.png"
                alt="Illustration showing unified review analysis across multiple platforms with sales data integration"
                style={{
                  display: 'block',
                  width: '100%',
                  height: 'auto'
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BenefitsSection; 